import { useState } from "react";

import {
  addCalleeFieldToCampaign,
  editCampaigncalleeField,
  deleteCalleeFieldFromCampaign
} from "src/graphql/campaignCalleeFields";
import { CampaignWithCalleeFields } from "src/graphql/generated/CampaignWithCalleeFields";
import { CampaignWithQuestions } from "src/graphql/generated/CampaignWithQuestions";
import {
  campaignCreateCalleeField,
  campaignCreateCalleeFieldVariables
} from "src/graphql/generated/campaignCreateCalleeField";
import {
  campaignDeleteCalleeField,
  campaignDeleteCalleeFieldVariables
} from "src/graphql/generated/campaignDeleteCalleeField";
import {
  campaignEditCalleeField,
  campaignEditCalleeFieldVariables
} from "src/graphql/generated/campaignEditCalleeField";
import { getCampaign_campaign } from "src/graphql/generated/getCampaign";
import { CalleeField } from "src/graphql/generated/globalTypes";
import useMutation from "src/util/useMutation";

import CalleeFields from "./CalleeFields";

export default function DataMapping({
  campaign,
  dataSourceFieldNames,
  dataSourceFieldLabel
}: {
  campaign: getCampaign_campaign &
    CampaignWithCalleeFields &
    CampaignWithQuestions;
  dataSourceFieldNames: string[];
  dataSourceFieldLabel: string;
}): JSX.Element {
  const [calleeFields, setCalleeFields] = useState(campaign.calleeFields);

  const refreshCampaignAfterMutation = {
    refetchQueries: ["getCampaign"],
    awaitRefetchQueries: true
  };

  const [addCalleeField] = useMutation<
    campaignCreateCalleeField,
    campaignCreateCalleeFieldVariables
  >(addCalleeFieldToCampaign, refreshCampaignAfterMutation);
  const handleAddField = async (
    name: string,
    dataSourceFieldName: string | null,
    builtInField?: CalleeField | null
  ) => {
    const { data, errors } = await addCalleeField({
      variables: {
        campaignId: campaign.id,
        input: {
          name,
          dataSourceFieldName,
          builtInField
        }
      }
    });
    if (errors) {
      throw errors;
    }
    if (data) {
      setCalleeFields(data.campaignCreateCalleeField.calleeFields);
    }
  };

  const [editCalleeField] = useMutation<
    campaignEditCalleeField,
    campaignEditCalleeFieldVariables
  >(editCampaigncalleeField, refreshCampaignAfterMutation);
  const handleEditField = async (
    fieldId: string,
    name: string,
    dataSourceFieldName: string | null
  ) => {
    const { data, errors } = await editCalleeField({
      variables: {
        campaignId: campaign.id,
        fieldId,
        input: {
          name,
          dataSourceFieldName
        }
      }
    });
    if (errors) {
      throw errors;
    }
    if (data) {
      setCalleeFields(data.campaignEditCalleeField.calleeFields);
    }
  };

  const [deleteCalleeField] = useMutation<
    campaignDeleteCalleeField,
    campaignDeleteCalleeFieldVariables
  >(deleteCalleeFieldFromCampaign, refreshCampaignAfterMutation);
  const handleDeleteField = async (fieldId: string) => {
    const { data, errors } = await deleteCalleeField({
      variables: { campaignId: campaign.id, fieldId }
    });
    if (errors) {
      throw errors;
    }
    if (data) {
      setCalleeFields(data.campaignDeleteCalleeField.calleeFields);
    }
  };

  return (
    <>
      <p>Contact Fields</p>
      <CalleeFields
        campaign={campaign}
        calleeFields={calleeFields}
        onAddField={handleAddField}
        onEditField={handleEditField}
        onDeleteField={handleDeleteField}
        dataSourceFieldNames={dataSourceFieldNames}
        dataSourceFieldLabel={dataSourceFieldLabel}
      />
    </>
  );
}
